export default [
    {
        title: "The End-All-Be-All",
        text: "With Shopify Systems, you have access to a network of skilled, designers and developers who work together to guarantee you the best product. We are your one-stop-shop for every need."
    },
    {
        title: "Dedicated Project Manager",
        text: "Our team is committed to you and your project. We guarantee you a Project Manager who will be in consistent contact with you to ensure success. Through our system of checks, you will be able to rest assured that your product is being treated with the utmost care."
    },
    {
        title: "Accountability",
        text: "We guarantee you a fully tested and working product. We pride ourselves on our ability to create beautiful, efficient stores in an appropriate amount of time. Say goodbye to inconsistency, and hello to your new store."
    },
]